import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InventoryService } from '../../../core/services/inventory.service';
import { ReportsService } from '../../../core/services/reports.service';

@Component({
  selector: 'app-generate-inventory-report-popup',
  templateUrl: './generate-inventory-report-popup.component.html',
  styleUrls: ['./generate-inventory-report-popup.component.scss'],
})
export class GenerateInventoryReportPopupComponent implements OnInit {
  @Output() handleGenerateInventoryReportOnChange: EventEmitter<any> =
    new EventEmitter();
  @Input() isVisibleGenerateInventoryReport = false;
  @Input() bookingData: any;
  @Input() inventoryId: any;

  recordId: any;
  editableRemarks = '';
  record: any;
  recordRemark = '';
  recordType = '';
  isPdfGenerated = false;
  pdf: any;
  generating = false;
  downloading = false;
  isLoading = false;
  haveRecord = false;
  haveBeforeDetails = false;
  haveAfterDetails = false;
  optionSelected = false;

  constructor(
    private inventoryService: InventoryService,
    private reportService: ReportsService,
  ) {}

  ngOnInit() {
    this.isLoading = true;
    this.inventoryService
      .getInventoryByFilter({ _id: this.inventoryId })
      .then((res: any) => {
        this.haveRecord = !!res;
        this.record = res;
        this.recordId = res?._id;
        this.haveBeforeDetails = !!this.record?.before?.date;
        this.haveAfterDetails = !!this.record?.after?.date;

        if (!this.haveBeforeDetails || !this.haveAfterDetails) {
          if (this.record?.before?.date) {
            this.optionSelected = true;
            this.recordType = 'Before';
            this.editableRemarks = this.record?.before?.remarks?.remark;
            this.recordRemark = this.record?.before?.remarks?.remark;
          } else if (this.record?.after?.date) {
            this.optionSelected = true;
            this.recordType = 'After';
            this.editableRemarks = this.record?.after?.remarks?.remark;
            this.recordRemark = this.record?.after?.remarks?.remark;
          }
        }
        this.isLoading = false;
      });
  }

  ngOnDestroy() {
    this.record = null;
    this.editableRemarks = '';
    this.recordRemark = '';
    this.isVisibleGenerateInventoryReport = false;
  }

  setSelectedDetails(type: string): void {
    this.optionSelected = true;
    this.isLoading = false;
    this.isPdfGenerated = false;
    this.pdf = null;
    if (type === 'before') {
      this.recordType = 'Before';
      this.editableRemarks = this.record?.before?.remarks?.remark;
      this.recordRemark = this.record?.before?.remarks?.remark;
    } else {
      this.recordType = 'After';
      this.editableRemarks = this.record?.after?.remarks?.remark;
      this.recordRemark = this.record?.after?.remarks?.remark;
    }
  }

  handleCancelGenerateInventoryReport(): void {
    this.handleGenerateInventoryReportOnChange.emit({
      name: 'visible',
      value: false,
    });
    this.isVisibleGenerateInventoryReport = false;
  }

  handleOkGenerateInventoryReport(): void {}

  handleUpdateInventoryRecord(): void {
    this.isLoading = true;
    if (this.recordType === 'Before') {
      this.record.before.remarks.remark = this.editableRemarks;
    } else {
      this.record.after.remarks.remark = this.editableRemarks;
    }
    this.inventoryService.updateInventory({ ...this.record }).then(() => {
      this.inventoryService.getInventoryById(this.recordId).then((res: any) => {
        this.record = res;
        if (this.recordType === 'Before') {
          this.recordType = 'Before';
          this.editableRemarks = this.record?.before?.remarks?.remark;
          this.recordRemark = this.record?.before?.remarks?.remark;
        } else {
          this.recordType = 'After';
          this.editableRemarks = this.record?.after?.remarks?.remark;
          this.recordRemark = this.record?.after?.remarks?.remark;
        }
        this.isLoading = false;
        this.isPdfGenerated = false;
        this.pdf = null;
      });
    });
  }

  handleCancel(): void {}

  generateReport(): void {
    this.generating = true;
    this.reportService
      .generateInventoryReportForThreeCompanies(this.recordId, {
        ...this.bookingData,
        recordType: this.recordType,
      })
      .then((res: any) => {
        this.pdf = res;
        this.generating = false;
        this.isPdfGenerated = true;
      });
  }

  previewReport(): void {
    this.reportService.viewReport(this.pdf);
  }

  printReport(): void {
    this.reportService.printReport(this.pdf);
  }

  downloadReport(): void {
    this.reportService.downloadReport(this.pdf).then((res: any) => {});
  }

  emailPdf(): void {
    this.reportService.emailPdf();
    // const email = 'recipient@gmail.com';
    // const subject = 'Your email subject';
    // const body = 'Your email body content';
    //
    // // Create the mailto link
    // // Open the default email client (Gmail, if available)
    // window.location.href = `mailto:${email}?subject=${encodeURIComponent(
    //   subject,
    // )}&body=${encodeURIComponent(body)}`;
  }
}
